<template>
  <div>
    <a class="btn btn-danger" @click.stop.prevent="preguntar">
      <i class="fa fa-trash"></i> {{ $I18n.t('Eliminar') }}
    </a>
    <ModalSimple v-model="showModal" :nivel-modal="2">
      <div class="text-left">
        <div class="titulo-seccion m-t-none">
          <i class="far fa-exclamation-circle text-cifra m-sm"></i>{{ $I18n.t('Confirmacion') }}
        </div>
        <p class="pregunta">
          {{ $I18n.t('seguro_eliminar_registro') }}
        </p>
        <div v-if="uuidRepeticion">
          <div v-for="tipo in tiposBorrado" :key="tipo" class="m-b-xs">
            <input-radio
              v-model="tipoBorrado"
              :value="tipo"
              name="tipoBorrado"
            >
              {{ $I18n.t(tipo) }}
            </input-radio>
          </div>
        </div>
        <div class="form-actions">
          <button class="btn btn-default" @click.prevent="hideModal">
            {{ $I18n.t('Cancelar') }}
          </button>
          <button class="btn btn-danger" @click.prevent="confirmado">
            {{ $I18n.t('Eliminar') }}
          </button>
        </div>
      </div>
    </ModalSimple>
  </div>
</template>

<script>
import ModalSimple from '../ModalSimple.vue';

export default {
  components: { ModalSimple },
  props: {
    eventoId: { type: Number, required: true },
    uuidRepeticion: { type: String, default: null },
  },
  data() {
    return {
      tipoBorrado: 'este_evento',
      tiposBorrado: ['este_evento', 'este_evento_posteriores', 'todos_eventos'],
      showModal: false,
    };
  },
  computed: {
    nombreModal() {
      return `modal-eliminar-evento-${this.eventoId}`;
    },
  },
  methods: {
    preguntar() {
      this.showModal = true;
    },
    confirmado() {
      this.hideModal();
      this.$emit('confirmado', {
        eventoId: this.eventoId,
        uuidRepeticion: this.uuidRepeticion,
        tipoBorrado: this.tipoBorrado,
      });
    },
    hideModal() {
      this.showModal = false;
    },
  },
};
</script>

<style scoped>
  .pregunta {
    font-size: 1.4em;
  }
  .form-actions {
    padding-top: 30px;
  }
</style>
